module.exports = __webpack_public_path__ + "static/media/pointer-regulament.47290d4a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pointer-regulament.svg
// module id = 90
// module chunks = 0